module.exports = __webpack_public_path__ + "img/fundermax-slider-3.2f8b796e.jpg";